import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AttendanceLogs = () => {
  const [attendanceLogs, setAttendanceLogs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentLog, setCurrentLog] = useState(null);
  const [date, setDate] = useState('');
  const [status, setStatus] = useState('');
  const [studentName, setStudentName] = useState('');

  const fetchLogs = async () => {
    try {
      const response = await axios.get('http://localhost:8081/api/get-attendance');
      setAttendanceLogs(response.data);
    } catch (error) {
      console.error('Failed to fetch logs:', error);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className="attendance-logs">
      <div className="header">
        <h2>Attendance Logs</h2>
      </div>

      {/* Table */}
      <table className="attendance-logs-table">
        <thead>
          <tr>
            <th>Student Name</th>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {attendanceLogs.map((log) => (
            <tr key={log.id}>
              <td>{log.student_name}</td>
              <td>{log.date}</td>
              <td>{log.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceLogs;
